import { Box, Paper, alpha, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import PageContainer from '../container/PageContainer';
import Logo from '../../layouts/full/shared/logo/Logo';

type AuthPageShellProps = {
  children: ReactNode;
  onLogoClick?: () => void;
};

function AuthPageShell({ children, onLogoClick }: AuthPageShellProps) {
  const theme = useTheme();

  return (
    <PageContainer>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          py: 4,
          bgcolor: 'background.default',
          backgroundImage: `radial-gradient(ellipse at top, ${alpha(theme.palette.primary.main, 0.08)} 0%, transparent 55%)`,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            maxWidth: 450,
            p: { xs: 3, sm: 4 },
            borderRadius: 4,
            border: '1px solid',
            borderColor: alpha(theme.palette.primary.main, 0.2),
            bgcolor: 'background.paper',
            boxShadow: theme.shadows[1],
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            mb={1}
            onClick={onLogoClick}
            sx={onLogoClick ? { cursor: 'pointer' } : undefined}
          >
            <Logo />
          </Box>
          {children}
        </Paper>
      </Box>
    </PageContainer>
  );
}

export default AuthPageShell;
